import type { LucideIcon } from 'lucide-react';

import styles from './FeatureCard.module.css';

interface FeatureCardProps {
  body: string;
  icon: LucideIcon;
  title: string;
}

export function FeatureCard({ body, icon: Icon, title }: FeatureCardProps) {
  return (
    <article className={styles.card}>
      <span aria-hidden="true" className={styles.icon}>
        <Icon size={22} strokeWidth={2.2} />
      </span>
      <div className={styles.copy}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.body}>{body}</p>
      </div>
    </article>
  );
}
